import { useState } from "react";

import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { TextAreaWithCount } from "../../../components/Inputs";

interface IProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (note: string) => void;
}

const MAX_LENGTH = 1000;

export const ConfirmationModal = ({ show, onHide, onConfirm }: IProps) => {
  const [note, setNote] = useState("");
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm(note.trim());
    setNote("");
    onHide();
  };

  const exceededMaxLength = note.length > MAX_LENGTH;
  // The user can leave it empty but is not allowed to just send whitespaces
  const isOnlyWhitespace = note.length > 0 && note.trim().length === 0;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("common.schoolCandidateModel.confirmationModalTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextAreaWithCount
          ariaLabel={t("common.schoolCandidateModel.confirmationModalNote")}
          label={t("common.schoolCandidateModel.confirmationModalNote")}
          value={note}
          onChange={setNote}
          maxLength={MAX_LENGTH}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color="warning" onClick={onHide}>
          {t("common.cancel")}
        </Button>
        <Button
          color="primary"
          onClick={handleConfirm}
          disabled={exceededMaxLength || isOnlyWhitespace}
        >
          {t("common.confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
